/**
 * Retorna datos adicionales formateado
 * @param {String} text 
 * @returns String
 */
export default function formatearDatosAdicionales(text) {
    var finalStringDatos = "";
    var arrStr = text.split(/[:;]/);
    arrStr = arrStr.filter(s => s).map(Function.prototype.call, String.prototype.trim);

    arrStr = arrStr.reduce(function (result, value, index, array) {
        if (index % 2 === 0)
            result.push(array.slice(index, index + 2));
        return result;
    }, []);

    for (let i = 0; i < arrStr.length; i++) {
        if (arrStr[i][1]) {
            finalStringDatos += `${arrStr[i][0]}: ${arrStr[i][1].toUpperCase()}; `;
        }
    }
    finalStringDatos = finalStringDatos.trim();
    return finalStringDatos;
}